import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as procService from "../../services/procService";
import { DataTable, ProcBadge, amount, csvStamp, downloadCsv, orderKey } from "./procUi";
import { AppDropdown, EmptyState, LoadState, PageHeader, SecondaryButton, formatDate, inputStyle, pageStyle, useLoad } from "../../components/ui";

// Orders (buyer side): the purchase orders your awards created, with where each supplier stands.
const FILTERS = [
  { label: "All orders", value: null },
  { label: "Awarded: waiting for the supplier", value: "3" },
  { label: "Accepted", value: "6" },
  { label: "Shipped", value: "8" },
  { label: "Out for delivery", value: "9" },
  { label: "Delivered: ready to complete", value: "10" },
  { label: "Completed", value: "15" },
  { label: "Rejected or cancelled", value: "4" },
];

export default function Orders() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [typed, setTyped] = useState("");
  const [q, setQ] = useState("");
  useEffect(() => {
    const t = setTimeout(() => setQ(typed.trim()), 300);
    return () => clearTimeout(t);
  }, [typed]);
  const { data, loading, error, reload } = useLoad(() => procService.listOrders({ status, q }), [status, q]);
  const exportCsv = () =>
    downloadCsv(`orders-${csvStamp()}.csv`, ["Order", "RFQ", "Title", "Supplier", "Status", "Currency", "Total", "Delivery date", "Invoices", "Purchase order status"], (data || []).map((o) => [o.order_number, o.rfq_number, o.rfq_title, o.company_name, o.status_label, o.currency, o.total, o.delivery_date || "", o.invoice_count || 0, o.po_status || ""]));

  return (
    <div style={pageStyle}>
      <PageHeader title="Orders" subtitle="Purchase orders from awarded RFQs. Goods are received against them in Inventory." actions={<SecondaryButton onClick={exportCsv} disabled={!(data || []).length}>Export CSV</SecondaryButton>} />
      <div className="d-flex flex-wrap gap-2 mb-3">
        <input className="form-control" style={{ ...inputStyle, maxWidth: 320 }} placeholder="Search orders" aria-label="Search orders" value={typed} onChange={(e) => setTyped(e.target.value)} />
        <div style={{ minWidth: 260 }}>
          <AppDropdown id="proc-order-status" value={status} options={FILTERS} onChange={(e) => setStatus(e.value ?? null)} aria-label="Status" />
        </div>
      </div>
      <LoadState loading={loading} error={error} onRetry={reload}>
        <DataTable
          rows={data || []}
          onRowClick={(o) => navigate(`/proc/orders/${o.id}`)}
          empty={<EmptyState title={q || status ? "No orders match" : "No orders yet"} text={q || status ? "Try another search or status." : "When an award is approved, a purchase order is created for each supplier and appears here."} />}
          columns={[
            { label: "Order", render: (o) => <><div style={{ fontWeight: 600, color: "#111827" }}>{o.order_number}</div><div style={{ fontSize: 12, color: "#6B7280" }}>{o.rfq_number} · {o.rfq_title}</div></> },
            { label: "Supplier", render: (o) => o.company_name },
            { label: "Status", render: (o) => <ProcBadge status={orderKey(o.status)} label={o.status_label} /> },
            { label: "Total", render: (o) => `${o.currency} ${amount(o.total)}`, style: { whiteSpace: "nowrap" } },
            { label: "Delivery", render: (o) => (o.delivery_date ? formatDate(o.delivery_date) : "—") },
            { label: "Invoices", render: (o) => o.invoice_count || "—" },
            { label: "Purchase order", render: (o) => o.po_status || "—" },
          ]}
        />
      </LoadState>
    </div>
  );
}
